export function platformDisplayName(platform) {
  if (typeof platform !== 'string') return platform
  return platform.trim().toLowerCase() === 'twitter' ? 'X (Twitter)' : platform
}



// WEBPACK FOOTER //
// ./src/utils/platformDisplay.js